import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TokenModule } from '@core/auth/token/token.module';
import { DecoratorInjectModule } from '@core/app/decorator-inject.module';
import { provideToastr } from 'ngx-toastr';
import { DefaultPushConfig } from '@core/push/push.config';
import { BsDatePickerDeps, DomDeps, startupAppConfigs, startupDeps } from '@core/app/app.module.helpers';
import { LocalizationModule } from '@core/localization/localization.module';
import { ApiModule } from '@api/api.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { provideNgxWebstorage, withLocalStorage, withSessionStorage } from 'ngx-webstorage';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { TitleStrategy } from '@angular/router';
import { BoTitleStrategy } from '@core/seo/title.strategy';


export const commonAppConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(TokenModule, DecoratorInjectModule, LocalizationModule, ApiModule, BsDatepickerModule, TimepickerModule),
        provideAnimations(),
        ...DomDeps,
        ...BsDatePickerDeps,
        {
            provide: APP_INITIALIZER,
            useFactory: startupAppConfigs,
            deps: startupDeps,
            multi: true,
        },
        provideToastr(DefaultPushConfig),
        provideNgxWebstorage(withLocalStorage(), withSessionStorage()),
        provideHttpClient(withInterceptorsFromDi()),
        { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
        { provide: TitleStrategy, useExisting: BoTitleStrategy },
    ],
};
